import React from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import InputWrapper from "../../layout/inputWrapper";
import ButtonWrapper from "../../components/Button";



const Step2 = ({ formData, handleTabChange }) => {
    const { t } = useTranslation();
    const defaultValues = {
        ...formData,
        descriptionOfLand: {
          ...formData?.descriptionOfLand
        },
      };
    const { handleSubmit, control, setValue, watch, reset, getValues } = useForm({defaultValues});
    const onSubmit = (data) => {
        handleTabChange(2, data)
    };
    return (
        <section className="groupContainer">
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="formContainer">
                    <div className="formHeaderContainer">
                        <h2 className="formHeading">Location Information</h2>
                    </div>

                    <div className="formInputContainer">
                        <div className="columnWrapper">
                            <InputWrapper
                                label="Latitude"
                                control={control}
                                placeholder="Enter Latitude"
                                name="descriptionOfLand.googleMapCoordinates.[0].latitude"
                                type="textInput"
                                mandatory
                                defaultValue={formData?.descriptionOfLand?.googleMapCoordinates?.[0]?.latitude}
                                validation={{
                                    required: {
                                        value: true,
                                        message: "This field is required",
                                    },
                                }}
                                maxLength={10}
                            />
                            <InputWrapper
                                label="Longitude"
                                control={control}
                                placeholder="Enter Longitude"
                                name="descriptionOfLand.googleMapCoordinates.[0].longitude"
                                type="textInput"
                                mandatory
                                defaultValue={formData?.descriptionOfLand?.googleMapCoordinates?.[0]?.longitude}
                                validation={{
                                    required: {
                                        value: true,
                                        message: "This field is required",
                                    },
                                }}
                                maxLength={10}
                            />
                            <InputWrapper
                                label="Land Address"
                                control={control}
                                placeholder="Enter Land Address"
                                defaultValue={formData?.descriptionOfLand?.googleMapLocation}
                                name="descriptionOfLand.googleMapLocation"
                                type="textInput"
                                maxLength={150}
                                multiLine
                            />
                        </div>
                        <br />
                    </div>

                </div>
                <div className="footerContainer">
                    <div className="buttonWrapper">
                        <ButtonWrapper
                            variant="contained"
                            color="error"
                            size="medium"
                            label="Prev"
                            sx={{ backgroundColor: '#CCC' }}
                            onClick={() => handleTabChange(0)}
                        />
                        <ButtonWrapper
                            variant="contained"
                            color="success"
                            size="medium"
                            label="Save"
                            type="submit"
                            sx={{ backgroundColor: '#157CB3' }}
                        />
                    </div>
                </div>
            </form>

        </section>
    );
};

export default Step2;
